import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { IconButton, Slide } from "@mui/material";
import { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import translate from "../../services/translation/lang";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useHotkeys } from "react-hotkeys-hook";
import { currencyFormatter } from "../../services/helpers/number-formatter";
import { isCurrencyHidden } from "../../services/helpers/login-params";
import "react-tabs/style/react-tabs.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function BetHistoryInfo({ open, handleClose }) {
  const descriptionElementRef = useRef(null);
  const [scroll] = useState("paper");
  const dispatch = useDispatch();
  const login = useSelector((state) => state.login);
  const betHistoryList = useSelector(
    (state) => state.betHistory.betHistoryList
  );

  useHotkeys("*", (event) => {
    if (open) {
      handleClose();
    }
  });

  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  useEffect(() => {
    if (open) {
      dispatch({
        type: "WEBSOCKET_SEND",
        payload: [
          "bet_history",
          {
            sid: login.sid
          },
        ],
      });
      //dispatch(getBetHistory({ session_id: login?.SessionID }));
      //dispatch(getPlayerBonusHistory({ session_id: login?.SessionID }));

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const formatDate = (dateString) => {
    const date = moment.utc(dateString).local();
    const formattedDate = date.format("YYYY-MM-DD"); // Formats as YYYY-MM-DD
    const formattedTime = date.format("HH:mm:ss"); // Formats as HH:MM:SS
    return { formattedDate, formattedTime };
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll={scroll}
      TransitionComponent={Transition}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="hotkey-modal difficulity-modal bet-history-modal"
    >
      {/* <div className="sign-pole left"></div>
      <div className="sign-pole right"></div> */}
      <div className="difficulty-info-title">
        {translate("bet_history")}
        <IconButton
          edge="start"
          color="inherit"
          onClick={handleClose}
          aria-label="close"
          className="close-icon-holder"
          size="small"
        >
          <div className="close-icon"></div>
        </IconButton>
      </div>
      <DialogContent
        dividers={scroll === "paper"}
        id="scroll-dialog-description"
        ref={descriptionElementRef}
        tabIndex={-1}
      >
            {" "}
            <div className="bet-history-table-holder">
              {betHistoryList.length ? (
                <Table>
                  <Thead>
                    <Tr>
                      <Th>{translate("ticket_id")}</Th>
                      <Th>{translate("created")}</Th>
                      {!isCurrencyHidden && <Th>{translate("currency")}</Th>}
                      <Th>{translate("bet")}</Th>
                      <Th>{translate("multiplier")}</Th>
                      <Th>{translate("win")}</Th>
                      <Th>{translate('difficulty')}</Th>
                      <Th>{translate("type")}</Th>
                      <Th>{translate("rows")}</Th>
                    </Tr>
                  </Thead>

                  <Tbody>
                    {betHistoryList.map((ticket) => {
                      const { formattedDate, formattedTime } = formatDate(
                        ticket?.created_time
                      );
                      return (
                        <Tr key={ticket?.ticket_id}>
                          <Td>{ticket?.ticket_id}</Td>
                          <Td>
                            {formattedDate} <br className="hide-br" />
                            {formattedTime}
                          </Td>
                          {!isCurrencyHidden && <Td>{ticket?.currency_code}</Td>}
                          <Td>{currencyFormatter(ticket?.betAmount)}</Td>
                          <Td>{ticket?.mp}x</Td>
                          <Td>{currencyFormatter(ticket?.win)}</Td>
                          <Td>{ticket?.difficulty === 1 ? translate("easy") : ticket?.difficulty === 2 ? translate("medium") : ticket?.difficulty === 3 ? translate("hard"): ""}</Td>
                          <Td>{ticket?.type}</Td>
                          <Td>{ticket?.rows}</Td>
                        </Tr>
                      );
                    })}
                  </Tbody>
                </Table>
              ) : (
                <div className="no-data">{translate("no_betting_history")}</div>
              )}
            </div>
      </DialogContent>
    </Dialog>
  );
}
